// Espejo de src/services/importExport/definitions/ordenTarea.definition.ts (ORDEN_TAREA_COLUMNS).
// Las columnas *_nombre / *_desc son readonly: se exportan pero se ignoran al importar.
export const ORDEN_TAREA_COLUMNS = [
  { key: 'id', label: 'id', type: 'number' },
  { key: 'description', label: 'description', type: 'string', required: true },
  { key: 'id_ascensor', label: 'id_ascensor', type: 'number' },
  { key: 'equipo_nombre', label: 'equipo_nombre', type: 'string', readonly: true },
  { key: 'planned_start', label: 'planned_start', type: 'string' },
  { key: 'planned_end', label: 'planned_end', type: 'string' },
  { key: 'sort_order', label: 'sort_order', type: 'number' },
  { key: 'parent_id', label: 'parent_id', type: 'number' },
  { key: 'id_responsable', label: 'id_responsable', type: 'number' },
  { key: 'responsable_nombre', label: 'responsable_nombre', type: 'string', readonly: true },
  { key: 'id_hallazgo', label: 'id_hallazgo', type: 'number' },
  { key: 'hallazgo_desc', label: 'hallazgo_desc', type: 'string', readonly: true },
  { key: 'id_coleccion_item', label: 'id_coleccion_item', type: 'number' },
  { key: 'material_nombre', label: 'material_nombre', type: 'string', readonly: true },
  { key: 'cantidad', label: 'cantidad', type: 'number' },
];
